export default __webpack_public_path__ + "static/media/prequest-am-mockup.ccd5a7dc.png";